export default __webpack_public_path__ + "static/media/spark_74.e40064c2.png";